<div class="content-container">

    <h4>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_clinic_name)}}</h4><br>
    <h1>Formular acordare consimțământ</h1><br>

    <p> Subsemnat(ul/a)   <b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_prenumePacient)}}
                            {{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_numePacient)}}</b>,
        domiciliat(ă) în <b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_addrPacient)}}</b>,
        adresă de email <b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_email)}}</b>,
        telefon <b>{{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_phone)}}</b>,

        în calitate de pacient(ă) al {{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_clinic_name)}}
    </p>
    <br>
    <b>Declar prin prezenta că am citit și am luat la cunoștință conținutul Notei de informare privind prelucrarea datelor cu caracter personal adresată clienților {{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_clinic_name)}}</b>
    <ul>
        <li>{{replacePlaceHoldersIn(gdprQuestions[0].answsL1[0])}}</li>
        <li>{{replacePlaceHoldersIn(gdprQuestions[0].answsL1[1])}}</li>
    </ul>
    <br>
    <p><b>Îmi exprim consimțământul expres, liber, neechivoc și specific cu privire la:</b></p>
    <p>1. Primirea de informații privind produsele și serviciile medicale furnizate de {{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_clinic_name)}}</p>
    <ul>
        <li>{{replacePlaceHoldersIn(gdprQuestions[1].answsL1[0])}}</li>
        <li>
            {{replacePlaceHoldersIn(gdprQuestions[1].answsL1[1])}}
        </li>
    </ul>

    <p>Prin:</p>
    <ul>
        <li>{{replacePlaceHoldersIn(gdprQuestions[1].answsL2[0])}}</li>
        <li>{{replacePlaceHoldersIn(gdprQuestions[1].answsL2[1])}}</li>
        <li>{{replacePlaceHoldersIn(gdprQuestions[1].answsL2[2])}}</li>
        <li>{{replacePlaceHoldersIn(gdprQuestions[1].answsL2[3])}}</li>
    </ul>

    <p>2.	Prelucrarea de către {{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_clinic_name)}}, în calitate de Operator, în scopuri de promovare și publicitate</p>
    <ul>
        <li>{{replacePlaceHoldersIn(gdprQuestions[2].answsL1[0])}}</li>
        <li>{{replacePlaceHoldersIn(gdprQuestions[2].answsL1[1])}}</li>
    </ul>

    <p>A următoarelor date cu caracter personal:</p>
    <ul>
        <li>{{replacePlaceHoldersIn(gdprQuestions[2].answsL2[0])}}</li>
        <li>{{replacePlaceHoldersIn(gdprQuestions[2].answsL2[1])}}</li>
        <li>{{replacePlaceHoldersIn(gdprQuestions[2].answsL2[2])}}</li>
        <li>{{replacePlaceHoldersIn(gdprQuestions[2].answsL2[3])}}</li>
    </ul>

    <p><i>
        *Notă: Numele și prenumele vor fi prelucrate doar în cazul în care vă exprimați consimțământul atât cu privire la prelucrarea acestora cât și cu privire la prelucrarea a cel puțin unei alte categorii, deoarece prelucrarea numelui și prenumelui în mod singular nu este de natură a îndeplini scopurile de promovare și publicitate pentru care vi se solicită consimțământul prin prezentul formular.
    </i></p>
    <br>
    <ul>
        <li>{{replacePlaceHoldersIn(gdprQuestions[2].answsL2[4])}}</li>
        <li>{{replacePlaceHoldersIn(gdprQuestions[2].answsL2[5])}}</li>
        <li>{{replacePlaceHoldersIn(gdprQuestions[2].answsL2[6])}}</li>
        <li>{{replacePlaceHoldersIn(gdprQuestions[2].answsL2[7])}}</li>
    </ul>

    <br>
    <p><b>Neacordarea consimțământului pentru utilizarea datelor cu caracter personal identificate în prezentul formular are drept consecință imposibilitatea realizării acestor activități de prelucrare în scopurile detaliat prezentate în prezentul formular, dar nu afectează în niciun fel prestarea serviciilor {{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_clinic_name)}} către dumneavoastră.</b></p>
    <br>
    <p>Vă puteți retrage sau modifica consimțământul astfel acordat, în orice moment, prin transmiterea unei solicitări scrise cu utilizarea următoarelor coordonate:</p>
    <ul>
        <li>Adresă poștală: {{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_clinic_addr)}}</li>
        <li>Adresă de e-mail: {{getValueOfFieldWithName(docFields, BasicInfoFieldNames.basic_clinic_email)}}</li>
    </ul>
    <br>
    <p>Retragerea nu afectează prelucrările efectuate anterior datei primirii acestei solicitări din partea dumneavoastră.</p>

    <b>
        <table>
            <tr><td style="border: none;">Data:</td> <td style="border: none;"> {{getSignedDate()}}</td></tr>
            <tr><td style="border: none;">Semnătura</td><td style="border: none;"><div class="max-w-48"><img [src]="getSignatureBlobURL()"></div></td></tr>
        </table>
    </b>
</div>
